import china from '@/utils/China.json'
// 按需引入 echarts：仅注册地图与散点所需模块，避免打包完整库
import * as echarts from 'echarts/core'
import { MapChart, ScatterChart, EffectScatterChart } from 'echarts/charts'
import { GeoComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { useEffect, useRef } from 'react'
import locationIcon from '@/images/contact/location.png'

echarts.use([MapChart, ScatterChart, EffectScatterChart, GeoComponent, CanvasRenderer])

const MAP_NAME = 'china'

let mapRegistered = false

function MapFallback({ mapData }) {
  const chartRef = useRef(null)
  const chartInstance = useRef(null)

  useEffect(() => {
    if (!chartRef.current) return

    if (!mapRegistered) {
      echarts.registerMap(MAP_NAME, china)
      mapRegistered = true
    }

    if (!chartInstance.current || chartInstance.current.isDisposed()) {
      chartInstance.current = echarts.init(chartRef.current)
    }
    const chart = chartInstance.current

    chart.setOption({
      geo: {
        map: MAP_NAME,
        // 支持滚轮缩放与拖拽平移
        roam: true,
        // 默认视角落在京津冀，避免一进来就是全国小点；可继续缩放至全国
        center: [114.8, 38.3],
        zoom: 2.5,
        scaleLimit: { min: 1, max: 10 },
        label: {
          normal: { show: false },
          emphasis: { show: false },
        },
        itemStyle: {
          normal: {
            borderColor: 'rgba(235, 235, 235, 1)',
            areaColor: 'rgba(235, 235, 235, 1)',
          },
        },
      },
      series: [
        // 定位脉冲圈
        {
          type: 'effectScatter',
          coordinateSystem: 'geo',
          silent: true,
          rippleEffect: { brushType: 'stroke', scale: 3, period: 3.4 },
          symbolSize: 26,
          itemStyle: { color: 'rgba(0, 179, 215, 0.35)' },
          data: [{ value: mapData }],
        },
        // 厂区定位图标
        {
          type: 'scatter',
          coordinateSystem: 'geo',
          silent: true,
          z: 10,
          symbol: `image://${locationIcon}`,
          symbolSize: 26,
          symbolOffset: [0, -14],
          data: [{ value: mapData }],
        },
      ],
    })

    const onResize = () => chart.resize()
    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [mapData])

  // 卸载时销毁实例
  useEffect(() => {
    return () => {
      if (chartInstance.current && !chartInstance.current.isDisposed()) {
        chartInstance.current.dispose()
      }
    }
  }, [])

  return <div className="mapCanvas" ref={chartRef} />
}

export default MapFallback